import { sendGtmEvent } from "~/analytics/definitions";
import { ABTestLimit, DecodedTestInformation } from "./variationId";
import Cookie from "js-cookie";

const storageKey = "newVariationId";
const eligibleTestLimitKey = "eligibleABTestLimit";

export function getEligibleABTestLimit(): number {
  const testLimit = Cookie.get(eligibleTestLimitKey);
  if (!testLimit) {
    return ABTestLimit;
  }
  return parseInt(testLimit);
}

export function isFullTestIdInTestList(
  decodedTests: DecodedTestInformation[],
  fullTestId: string,
) {
  const testExistsInActiveTests = decodedTests.find(
    (test) => test.fullTestId === fullTestId,
  );
  return testExistsInActiveTests;
}

export function getCurrentVariationIdFromCookie(): string | undefined {
  return Cookie.get(storageKey);
}

export function updateEligibleTestLimit(newTestLimit: number): void {
  Cookie.set(eligibleTestLimitKey, newTestLimit.toString());
}

export function handleChangedVariationIdCookie(newVariationId: string) {
  Cookie.set(storageKey, newVariationId);
  sendGtmEvent({
    event: "newVariationId",
    variationId: newVariationId,
  });
}
